import classNames from 'classnames';
import { useEffect, useState } from 'react';
import 'react-calendar/dist/Calendar.css';
import { useSearchParams, Link } from 'react-router-dom';
import Button from '../../components/bootstrap/Button';

import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../components/bootstrap/Card';
import Spinner from '../../components/bootstrap/Spinner';

import downloadFile from '../../helpers/downloadFiles';
import Page from '../../layout/Page/Page';

// import GalleryModal from './GalleryModal';
// GalleryModal
import { useTranslation } from 'react-i18next';

import ImageViewer from '../../components/ImageViewer';
import { getFileTypeFromUrl } from '../../helpers/helpers';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../layout/SubHeader/SubHeader';
import Input from '../../components/bootstrap/forms/Input';
import axios from 'axios';

const TrackingVehicle = () => {
	const { t } = useTranslation();

	const [searchParams] = useSearchParams();
	const vin_number = searchParams.get('vin_number');
	const [vinNumber, setVinNumber] = useState(vin_number ?? '');
	const [vehicle, setIsVehicle] = useState({});
	const [loading, setloading] = useState(false);
	const [tabActivePhotos, setTabActivePhotos] = useState('3');
	const [tabActiveDocuments, setTabActiveDocuments] = useState('1');

	const handleTrackingApiCall = (vinNumberParam) => {
		setloading(true);
		axios
			.get(`${process.env.REACT_APP_API_BASE_URL}/track-vehicle?vin_number=${vinNumberParam}`)
			.then((res) => {
				setIsVehicle(res?.data);
			})
			.catch(() => {
				setIsVehicle(null);
			})
			.finally(() => {
				setloading(false);
			});
	};

	useEffect(() => {
		if (vinNumber) {
			handleTrackingApiCall(vinNumber);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// const [claimInfo, setCliamInfo] = useState({});
	const [loader, setLoader] = useState(false);
	const [loader1, setLoader1] = useState(false);
	const [loader2, setLoader2] = useState(false);
	const [loader3, setLoader3] = useState(false);
	const [loader4, setLoader4] = useState(false);
	const [loader5, setLoader5] = useState(false);
	const [loader6, setLoader6] = useState(false);

	const _handleTabPhotos = (tab) => {
		setTabActivePhotos(tab);
	};

	const _handleTabDocuments = (tab) => {
		setTabActiveDocuments(tab);
	};

	// Download Images
	const _handleDownloadFile = (type) => {
		let _url = `/vehicles/${id}/download-photos?type=`;
		let _fileName = `${vehicle?.vin_number}-${type}`;

		if (type === 'usa_yard_photos') {
			setLoader(true);
			downloadFile(`${_url}1`, _fileName, '.zip', setLoader);
		} else if (type === 'auction_photos') {
			setLoader1(true);
			downloadFile(`${_url}2`, _fileName, '.zip', setLoader1);
		} else if (type === 'pickup_photos') {
			setLoader2(true);
			downloadFile(`${_url}3`, _fileName, '.zip', setLoader2);
		} else if (type === 'arrived_photos') {
			setLoader3(true);
			downloadFile(`${_url}4`, _fileName, '.zip', setLoader3);
		} else if (type === 'export_photos') {
			setLoader6(true);
			downloadFile(`${_url}5`, _fileName, '.zip', setLoader6);
		}
	};

	// Download Documents
	const _handleDownloadInvoice = (type) => {
		let _url = `/vehicles/${id}/download-document?type=`;
		let _fileName = `${vehicle?.vin_number}-${type}`;

		if (type === 'documents') {
			setLoader4(true);
			downloadFile(`${_url}1`, _fileName, '.zip', setLoader4);
		} else if (type === 'invoices') {
			setLoader5(true);
			downloadFile(`${_url}2`, _fileName, '.zip', setLoader5);
		}
	};

	return (
		<>
			<div title={'Tracking'}>
				<SubHeader>
					<SubHeaderLeft>
						<Link to='/' aria-label='Logo' className='brand-logo'>
							<img
								src={`${process.env.REACT_APP_BASE_URL}/images/logo.png`}
								alt={`${process.env.REACT_APP_PROJECT_NAME}`}
								height={50}
								width={110}
							/>
						</Link>
					</SubHeaderLeft>
					<SubHeaderRight>PLine Shipping</SubHeaderRight>
				</SubHeader>
				<Page container='fluid'>
					<Card>
						<div>
							<CardHeader>
								<CardLabel icon='LocalShipping'>
									<CardTitle>{t('Tracking')}</CardTitle>
								</CardLabel>
							</CardHeader>
							<CardBody>
								<div className='d-flex gap-4' style={{ width: '100%' }}>
									<Input
										placeholder={t('Search by VIN Number')}
										className='py-2 '
										value={vinNumber}
										onChange={(e) => setVinNumber(e.target.value)}
										style={{ width: '25%' }}
									/>
									<Button
										color='info'
										icon='ManageSearch'
										isLight
										style={{ width: '152px' }}
										onClick={() => handleTrackingApiCall(vinNumber)}>
										{t('Search')}
									</Button>
								</div>
							</CardBody>
						</div>
						<div>
							{loading ? (
								<div className='d-flex justify-content-center'>
									<Spinner
										tag='div'
										color='primary'
										isGrow
										size='2rem'
										className='ms-2'
									/>
								</div>
							) : vehicle ? (
								<div>
									<Card>
										<CardHeader>
											<CardLabel icon='CameraAlt'>
												<CardTitle>{t('Photos')}</CardTitle>
											</CardLabel>
										</CardHeader>
										<CardBody className='pt-0'>
											{!loading && (
												<div>
													<nav>
														<div
															className='nav nav-tabs'
															id='nav-tab'
															role='tablist'>
															<button
																className={classNames('nav-link', {
																	active: tabActivePhotos === '1',
																})}
																id='nav-home-tab'
																type='button'
																role='tab'
																onClick={() =>
																	_handleTabPhotos('1')
																}>
																{t('Auction Photos')}
															</button>

															<button
																className={classNames('nav-link', {
																	active: tabActivePhotos === '2',
																})}
																id='nav-profile-tab'
																data-bs-toggle='tab'
																data-bs-target='#nav-profile'
																type='button'
																role='tab'
																onClick={() =>
																	_handleTabPhotos('2')
																}>
																{t('Pickup Photos')}
															</button>

															<button
																className={classNames('nav-link', {
																	active: tabActivePhotos === '3',
																})}
																id='nav-contact-tab'
																data-bs-toggle='tab'
																data-bs-target='#nav-contact'
																type='button'
																role='tab'
																onClick={() =>
																	_handleTabPhotos('3')
																}>
																{t('Yard Photos')}
															</button>
															<button
																className={classNames('nav-link', {
																	active: tabActivePhotos === '4',
																})}
																id='nav-disabled-tab'
																data-bs-toggle='tab'
																data-bs-target='#nav-disabled'
																type='button'
																role='tab'
																onClick={() =>
																	_handleTabPhotos('4')
																}>
																{t('Arrived Photos')}
															</button>
															<button
																className={classNames('nav-link', {
																	active: tabActivePhotos === '5',
																})}
																id='nav-disabled-tab'
																data-bs-toggle='tab'
																data-bs-target='#nav-disabled'
																type='button'
																role='tab'
																onClick={() =>
																	_handleTabPhotos('5')
																}>
																{t('Export Photos')}
															</button>
														</div>
													</nav>
													<div
														className='tab-content'
														id='nav-tabContent'>
														{/* Auction Photos */}
														<div
															className={classNames('tab-pane fade', {
																'show active':
																	tabActivePhotos === '1',
															})}
															role='tabpanel'>
															<CardHeader className='justify-content-end pb-0'>
																<CardActions>
																	{!loading &&
																		vehicle?.file_urls
																			?.auction_photos
																			?.length > 0 && (
																			<Button
																				icon='FileDownload'
																				color='info'
																				onClick={() =>
																					_handleDownloadFile(
																						'auction_photos',
																					)
																				}>
																				{t('Download File')}
																				{loader1 && (
																					<Spinner
																						tag='div'
																						color='light'
																						isGrow
																						size='1rem'
																						className='ms-2'
																					/>
																				)}
																			</Button>
																		)}
																</CardActions>
															</CardHeader>
															<CardBody>
																<div className='row'>
																	{loading && (
																		<div className='col-12 text-center'>
																			<Spinner
																				tag='div'
																				color='primary'
																				isGrow
																				size='5rem'
																				className=''
																			/>
																		</div>
																	)}
																	{!loading &&
																		vehicle?.file_urls
																			?.auction_photos
																			?.length === 0 && (
																			<div className='col-12 text-center'>
																				<p>
																					{t(
																						'No Photo Found',
																					)}
																				</p>
																			</div>
																		)}
																</div>

																{vehicle?.file_urls?.auction_photos
																	.length > 0 && (
																	<ImageViewer
																		imageUrls={
																			vehicle?.file_urls
																				?.auction_photos
																		}
																		alt={t('Auction Photos')}
																	/>
																)}
															</CardBody>
														</div>
														{/* Pickup Photos */}

														<div
															className={classNames('tab-pane fade', {
																'show active':
																	tabActivePhotos === '2',
															})}
															id='nav-profile'
															role='tabpanel'
															aria-labelledby='nav-profile-tab'>
															<CardHeader className='justify-content-end pb-0'>
																<CardActions>
																	{!loading &&
																		vehicle?.file_urls
																			?.pickup_photos
																			?.length > 0 && (
																			<Button
																				icon='FileDownload'
																				color='info'
																				onClick={() =>
																					_handleDownloadFile(
																						'pickup_photos',
																					)
																				}>
																				{t('Download File')}
																				{loader2 && (
																					<Spinner
																						tag='div'
																						color='light'
																						isGrow
																						size='1rem'
																						className='ms-2'
																					/>
																				)}
																			</Button>
																		)}
																</CardActions>
															</CardHeader>
															<CardBody>
																<div className='row'>
																	{loading && (
																		<div className='col-12 text-center'>
																			<Spinner
																				tag='div'
																				color='primary'
																				isGrow
																				size='5rem'
																				className=''
																			/>
																		</div>
																	)}
																	{!loading &&
																		vehicle?.file_urls
																			?.pickup_photos
																			?.length === 0 && (
																			<div className='col-12 text-center'>
																				<p>
																					{t(
																						'No Photo Found',
																					)}
																				</p>
																			</div>
																		)}
																</div>

																{vehicle?.file_urls?.pickup_photos
																	.length > 0 && (
																	<ImageViewer
																		imageUrls={
																			vehicle?.file_urls
																				?.pickup_photos
																		}
																		alt={t('Pickup Photos')}
																	/>
																)}
															</CardBody>
														</div>

														{/* USA Yard Photos */}
														<div
															className={classNames('tab-pane fade', {
																'show active':
																	tabActivePhotos === '3',
															})}
															id='nav-contact'
															role='tabpanel'
															aria-labelledby='nav-contact-tab'>
															<CardHeader className='justify-content-end pb-0'>
																<CardActions>
																	{vehicle?.file_urls?.yard_photos
																		?.length > 0 && (
																		<Button
																			icon='FileDownload'
																			color='info'
																			onClick={() =>
																				_handleDownloadFile(
																					'usa_yard_photos',
																				)
																			}>
																			{t('Download File')}
																			{loader && (
																				<Spinner
																					tag='div'
																					color='light'
																					isGrow
																					size='1rem'
																					className='ms-2'
																				/>
																			)}
																		</Button>
																	)}
																</CardActions>
															</CardHeader>
															<CardBody>
																<div className='row'>
																	{loading && (
																		<div className='col-12 text-center'>
																			<Spinner
																				tag='div'
																				color='primary'
																				isGrow
																				size='5rem'
																				className=''
																			/>
																		</div>
																	)}
																	{!loading &&
																		vehicle?.file_urls
																			?.yard_photos
																			?.length === 0 && (
																			<div className='col-12 text-center'>
																				<p>
																					{t(
																						'No Photo Found',
																					)}
																				</p>
																			</div>
																		)}
																</div>
																{vehicle?.file_urls?.yard_photos
																	?.length > 0 && (
																	<ImageViewer
																		imageUrls={
																			vehicle?.file_urls
																				?.yard_photos
																		}
																		alt={t('Yard Photos')}
																	/>
																)}
															</CardBody>
														</div>
														{/* Arrived Photos */}
														<div
															className={classNames('tab-pane fade', {
																'show active':
																	tabActivePhotos === '4',
															})}
															id='nav-disabled'
															role='tabpanel'
															aria-labelledby='nav-disabled-tab'>
															<CardHeader className='justify-content-end pb-0'>
																<CardActions>
																	{!loading &&
																		vehicle?.file_urls
																			?.arrived_photos
																			?.length > 0 && (
																			<Button
																				icon='FileDownload'
																				color='info'
																				onClick={() =>
																					_handleDownloadFile(
																						'arrived_photos',
																					)
																				}>
																				{t('Download File')}
																				{loader3 && (
																					<Spinner
																						tag='div'
																						color='light'
																						isGrow
																						size='1rem'
																						className='ms-2'
																					/>
																				)}
																			</Button>
																		)}
																</CardActions>
															</CardHeader>
															<CardBody>
																<div className='row'>
																	{loading && (
																		<div className='col-12 text-center'>
																			<Spinner
																				tag='div'
																				color='primary'
																				isGrow
																				size='5rem'
																				className=''
																			/>
																		</div>
																	)}
																	{!loading &&
																		vehicle?.file_urls
																			?.arrived_photos
																			?.length === 0 && (
																			<div className='col-12 text-center'>
																				<p>
																					{t(
																						'No Photo Found',
																					)}
																				</p>
																			</div>
																		)}
																</div>
																{vehicle?.file_urls?.arrived_photos
																	.length > 0 && (
																	<ImageViewer
																		imageUrls={
																			vehicle?.file_urls
																				?.arrived_photos
																		}
																		alt={t('Arrived Photos')}
																	/>
																)}
															</CardBody>
														</div>
														{/* Export Photos */}
														<div
															className={classNames('tab-pane fade', {
																'show active':
																	tabActivePhotos === '5',
															})}
															id='nav-disabled'
															role='tabpanel'
															aria-labelledby='nav-disabled-tab'>
															<CardHeader className='justify-content-end pb-0'>
																<CardActions>
																	{!loading &&
																		vehicle?.file_urls
																			?.export_photos
																			?.length > 0 && (
																			<Button
																				icon='FileDownload'
																				color='info'
																				onClick={() =>
																					_handleDownloadFile(
																						'export_photos',
																					)
																				}>
																				{t('Download File')}
																				{loader6 && (
																					<Spinner
																						tag='div'
																						color='light'
																						isGrow
																						size='1rem'
																						className='ms-2'
																					/>
																				)}
																			</Button>
																		)}
																</CardActions>
															</CardHeader>
															<CardBody>
																<div className='row'>
																	{loading && (
																		<div className='col-12 text-center'>
																			<Spinner
																				tag='div'
																				color='primary'
																				isGrow
																				size='5rem'
																				className=''
																			/>
																		</div>
																	)}
																	{!loading &&
																		vehicle?.file_urls
																			?.export_photos
																			?.length === 0 && (
																			<div className='col-12 text-center'>
																				<p>
																					{t(
																						'No Photo Found',
																					)}
																				</p>
																			</div>
																		)}
																</div>
																{vehicle?.file_urls?.export_photos
																	.length > 0 && (
																	<ImageViewer
																		imageUrls={
																			vehicle?.file_urls
																				?.export_photos
																		}
																		alt={t('Export Photos')}
																	/>
																)}
															</CardBody>
														</div>
													</div>
												</div>
											)}
										</CardBody>
									</Card>

									<Card>
										<CardHeader>
											<CardLabel icon='FileCopy'>
												<CardTitle>{t('Documents')}</CardTitle>
											</CardLabel>
										</CardHeader>
										<CardBody className='pt-0'>
											<div>
												<nav>
													<div
														className='nav nav-tabs'
														id='nav-tab'
														role='tablist'>
														<button
															className={classNames('nav-link', {
																active: tabActiveDocuments === '1',
															})}
															id='nav-home-tab'
															type='button'
															role='tab'
															onClick={() =>
																_handleTabDocuments('1')
															}>
															{t('Documents')}
														</button>
														<button
															className={classNames('nav-link', {
																active: tabActiveDocuments === '2',
															})}
															id='nav-profile-tab'
															data-bs-toggle='tab'
															data-bs-target='#nav-profile'
															type='button'
															role='tab'
															onClick={() =>
																_handleTabDocuments('2')
															}>
															{t('Invoice')}
														</button>
													</div>
												</nav>
												<div className='tab-content' id='nav-tabContent'>
													{/* Documents */}
													<div
														className={classNames('tab-pane fade', {
															'show active':
																tabActiveDocuments === '1',
														})}
														role='tabpanel'>
														<CardHeader className='justify-content-end pb-0'>
															<CardActions>
																{!loading &&
																	vehicle?.file_urls?.documents
																		?.length > 0 && (
																		<Button
																			icon='FileDownload'
																			color='info'
																			onClick={() =>
																				_handleDownloadInvoice(
																					'documents',
																				)
																			}>
																			{t('Download File')}
																			{loader4 && (
																				<Spinner
																					tag='div'
																					color='light'
																					isGrow
																					size='1rem'
																					className='ms-2'
																				/>
																			)}
																		</Button>
																	)}
															</CardActions>
														</CardHeader>
														<CardBody>
															<div className='row'>
																{loading && (
																	<div className='col-12 text-center'>
																		<Spinner
																			tag='div'
																			color='primary'
																			isGrow
																			size='5rem'
																		/>
																	</div>
																)}
																{!loading &&
																	vehicle?.file_urls?.documents
																		?.length === 0 && (
																		<div className='col-12 text-center'>
																			<p>
																				{t(
																					'No Document Found',
																				)}
																			</p>
																		</div>
																	)}
															</div>
															<div className='vehicle-img-details'>
																{vehicle?.file_urls?.documents
																	?.length > 0 &&
																	vehicle?.file_urls?.documents.map(
																		(single) => (
																			<div
																				className='single'
																				key={
																					single?.url ??
																					single
																				}>
																				{getFileTypeFromUrl(
																					single,
																				) !==
																					'application/pdf' &&
																					single?.type !==
																						'pdf' && (
																						<img
																							src={
																								single?.url ??
																								single
																							}
																							alt=''
																							className='img-holder'
																						/>
																					)}

																				{(getFileTypeFromUrl(
																					single,
																				) ===
																					'application/pdf' ||
																					single.type ===
																						'pdf') && (
																					<iframe
																						src={
																							single?.url ??
																							single
																						}
																						title={
																							single?.name ??
																							single
																						}
																						frameBorder='0'
																						height={200}
																						width={
																							160
																						}></iframe>
																				)}
																			</div>
																		),
																	)}
															</div>
														</CardBody>
													</div>
													{/* Invoice */}
													<div
														className={classNames('tab-pane fade', {
															'show active':
																tabActiveDocuments === '2',
														})}
														id='nav-profile'
														role='tabpanel'
														aria-labelledby='nav-profile-tab'>
														<CardHeader className='justify-content-end pb-0'>
															<CardActions>
																{!loading &&
																	vehicle?.file_urls?.invoices
																		?.length > 0 && (
																		<Button
																			icon='FileDownload'
																			color='info'
																			onClick={() =>
																				_handleDownloadInvoice(
																					'invoices',
																				)
																			}>
																			{t('Download File')}
																			{loader5 && (
																				<Spinner
																					tag='div'
																					color='light'
																					isGrow
																					size='1rem'
																					className='ms-2'
																				/>
																			)}
																		</Button>
																	)}
															</CardActions>
														</CardHeader>
														<CardBody>
															<div className='row'>
																{loading && (
																	<div className='col-12 text-center'>
																		<Spinner
																			tag='div'
																			color='primary'
																			isGrow
																			size='5rem'
																			className=''
																		/>
																	</div>
																)}
																{!loading &&
																	vehicle?.file_urls?.invoices
																		?.length == 0 && (
																		<div className='col-12 text-center'>
																			<p>
																				{t(
																					'No Document Found',
																				)}
																			</p>
																		</div>
																	)}
															</div>
															<div className='vehicle-img-details'>
																{vehicle?.file_urls?.invoices
																	?.length > 0 &&
																	vehicle?.file_urls?.invoices.map(
																		(single) => (
																			<div
																				className='single'
																				key={
																					single?.url ??
																					single
																				}>
																				{getFileTypeFromUrl(
																					single,
																				) !==
																					'application/pdf' &&
																					single.type !==
																						'pdf' && (
																						<img
																							src={
																								single?.url ??
																								single
																							}
																							alt=''
																							className='img-holder'
																						/>
																					)}

																				{(getFileTypeFromUrl(
																					single,
																				) ===
																					'application/pdf' ||
																					single?.type ===
																						'pdf') && (
																					<iframe
																						src={
																							single?.url ??
																							single
																						}
																						title={
																							single?.name ??
																							single
																						}
																						frameBorder='0'
																						height={200}
																						width={
																							160
																						}></iframe>
																				)}
																			</div>
																		),
																	)}
															</div>
														</CardBody>
													</div>
												</div>
											</div>
										</CardBody>
									</Card>

									{/* handed over info */}

									{vehicle?.status === 80 && (
										<Card>
											<CardHeader>
												<CardLabel className='mb-0' icon='ElectricCar'>
													<CardTitle>
														{t('Handed Over Information')}
													</CardTitle>
												</CardLabel>
											</CardHeader>
											<CardBody>
												<div className='row'>
													{loading && (
														<div className='col-12 text-center'>
															<Spinner
																tag='div'
																color='primary'
																isGrow
																size='5rem'
																className=''
															/>
														</div>
													)}
													{!loading && !vehicle?.id && (
														<div className='col-12 text-center'>
															<p>{t('No Record Found')}</p>
														</div>
													)}
													<div className='row'>
														<div className='col-sm-12 col-lg-6'>
															<table className='table table-modern'>
																<tbody>
																	<tr>
																		<td>
																			<strong>
																				{' '}
																				{t(
																					'Handed Over To',
																				)}{' '}
																			</strong>
																		</td>
																		<td>:</td>
																		<td>
																			{
																				vehicle
																					?.handed_over_info
																					?.handed_over_to
																			}
																		</td>
																	</tr>

																	<tr>
																		<td>
																			<strong>
																				{t(
																					'Handed Over At',
																				)}
																			</strong>
																		</td>
																		<td>:</td>
																		<td>
																			{
																				vehicle
																					?.handed_over_info
																					?.handed_over_at
																			}
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
														<div className='col-sm-12 col-lg-6'>
															<table className='table table-modern'>
																<tbody>
																	<tr>
																		<td>
																			<strong>
																				{' '}
																				{t(
																					'Handed Over By',
																				)}{' '}
																			</strong>
																		</td>
																		<td>:</td>
																		<td>
																			{' '}
																			{
																				vehicle
																					?.handed_over_info
																					?.handed_over_by
																			}
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
													<div className='row mt-4'>
														{vehicle?.handed_over_info?.photos.length >
															0 && (
															<ImageViewer
																imageUrls={
																	vehicle?.handed_over_info
																		?.photos
																}
																alt={t('Handeded Over Photos')}
															/>
														)}
													</div>
												</div>
											</CardBody>
										</Card>
									)}

									{/* Vehicle  Details */}
									<Card>
										<CardHeader>
											<CardLabel className='mb-0' icon='ElectricCar'>
												<CardTitle>{t('Vehicle Detail')}</CardTitle>
											</CardLabel>
										</CardHeader>
										<CardBody>
											<div className='row'>
												{loading && (
													<div className='col-12 text-center'>
														<Spinner
															tag='div'
															color='primary'
															isGrow
															size='5rem'
															className=''
														/>
													</div>
												)}
												{!loading && !vehicle?.id && (
													<div className='col-12 text-center'>
														<p>{t('No Record Found')}</p>
													</div>
												)}
												<div className='row'>
													<div className='col-sm-12 col-lg-6'>
														<table className='table table-modern'>
															<tbody>
																<tr>
																	<td
																		style={{
																			width: '50%',
																		}}>
																		<strong>
																			{t('Cunstomer Name')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td
																		style={{
																			width: '40%',
																		}}>
																		{vehicle?.customer_name}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Company Name')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.company_name}</td>
																</tr>

																<tr>
																	<td>
																		<strong>{t('Year')}</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.year}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{t('Make')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.make}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Model')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.model}</td>
																</tr>

																<tr>
																	<td>
																		<strong>
																			{t('Purchase Date')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{vehicle?.purchase_date}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Paid Date')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.paid_date}</td>
																</tr>
																{vehicle?.status === 80 && (
																	<tr>
																		<td>
																			<strong>
																				{t(
																					'Handed Over Date',
																				)}{' '}
																			</strong>
																		</td>
																		<td>:</td>
																		<td>
																			{
																				vehicle?.handed_over_date
																			}
																		</td>
																	</tr>
																)}
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('VIN')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td> {vehicle?.vin_number}</td>
																</tr>
																<tr>
																	<td
																		style={{
																			width: '50%',
																		}}>
																		<strong>
																			{' '}
																			{t('Color')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td
																		style={{
																			width: '40%',
																		}}>
																		{' '}
																		{vehicle?.color}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Yard')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{vehicle?.location_name}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div className='col-sm-12 col-lg-6'>
														<table className='table table-modern'>
															<tbody>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Keys')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td> {vehicle?.keys_name}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Weight')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.weight}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Value')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td> {vehicle?.value}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{t('Buyer Number')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{vehicle?.license_number}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Lot Number')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td> {vehicle?.lot_number}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t(
																				'Storage Amount',
																			)}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{' '}
																		{vehicle?.storage_amount}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Check Number')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{' '}
																		{vehicle?.check_number}
																	</td>
																</tr>

																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t('Add. CHGS')}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{
																			vehicle?.additional_charges
																		}
																	</td>
																</tr>

																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t(
																				'Service Provider',
																			)}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{vehicle?.service_provider}
																	</td>
																</tr>

																<tr>
																	<td>
																		<strong>
																			{' '}
																			{t(
																				'Sub Lot Location',
																			)}{' '}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{vehicle?.sub_lot_location}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</CardBody>
									</Card>

									<Card>
										<CardBody>
											<div className='row'>
												<p className='lead fw-bold'>
													{t('Towing Request Information')}
												</p>
												<div className='col-sm-12 col-lg-6'>
													<table className='table table-modern'>
														<tbody>
															<tr>
																<td style={{ width: '50%' }}>
																	<strong>
																		{t('Condition')}
																	</strong>
																</td>
																<td>:</td>
																<td style={{ width: '40%' }}>
																	{vehicle?.condition === '1'
																		? t('Yes')
																		: t('No')}
																</td>
															</tr>
															<tr>
																<td>
																	<strong>{t('Damaged')}</strong>
																</td>
																<td>:</td>
																<td>
																	{vehicle?.damaged === '1'
																		? t('Yes')
																		: t('No')}
																</td>
															</tr>
															<tr>
																<td>
																	<strong>{t('Pictures')}</strong>
																</td>
																<td>:</td>
																<td>
																	{vehicle?.pictures === '1'
																		? t('Yes')
																		: t('No')}
																</td>
															</tr>
															<tr>
																<td>
																	<strong>{t('Towed')}</strong>
																</td>
																<td>:</td>
																<td>
																	{vehicle?.towed === '1'
																		? t('Yes')
																		: t('No')}
																</td>
															</tr>
															<tr>
																<td>
																	<strong>
																		{t('Towed From')}
																	</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.city_name}</td>
															</tr>
															<tr>
																<td style={{ width: '50%' }}>
																	<strong>
																		{t('Towed Fee')}
																	</strong>
																</td>
																<td>:</td>
																<td style={{ width: '40%' }}>
																	{vehicle?.tow_fee}
																</td>
															</tr>
															<tr>
																<td>
																	<strong>
																		{t('Towing Request Date')}
																	</strong>
																</td>
																<td>:</td>
																<td>
																	{vehicle?.towing_request_date}
																</td>
															</tr>
														</tbody>
													</table>
												</div>
												<div className='col-sm-12 col-lg-6'>
													<table className='table table-modern'>
														<tbody>
															<tr>
																<td style={{ width: '50%' }}>
																	<strong>{t('Country')}</strong>
																</td>
																<td>:</td>
																<td style={{ width: '40%' }}>
																	{vehicle?.country_name}
																</td>
															</tr>
															<tr>
																<td style={{ width: '50%' }}>
																	<strong>{t('State')}</strong>
																</td>
																<td>:</td>
																<td style={{ width: '40%' }}>
																	{vehicle?.state_name}
																</td>
															</tr>
															<tr>
																<td style={{ width: '50%' }}>
																	<strong>{t('City')}</strong>
																</td>
																<td>:</td>
																<td style={{ width: '40%' }}>
																	{vehicle?.city_name}
																</td>
															</tr>

															<tr>
																<td>
																	<strong>
																		{t('Pickup Date')}
																	</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.pickup_date}</td>
															</tr>
															<tr>
																<td>
																	<strong>
																		{t('Deliver date')}
																	</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.deliver_date}</td>
															</tr>
															<tr>
																<td>
																	<strong>{t('Note')}</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.note}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</CardBody>
									</Card>
									<Card>
										<CardBody>
											<div className='row'>
												<p className='lead fw-bold'>
													{t('Title Information')}
												</p>
												<div className='col-sm-12 col-lg-6'>
													<table className='table table-modern'>
														<tbody>
															<tr>
																<td style={{ width: '50%' }}>
																	<strong>
																		{t('Title Status')}
																	</strong>
																</td>
																<td>:</td>
																<td style={{ width: '40%' }}>
																	{vehicle?.title == 1
																		? 'Yes'
																		: 'No'}
																</td>
															</tr>
															<tr>
																<td>
																	<strong>
																		{t('Title Amount')}
																	</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.title_amount}</td>
															</tr>
															<tr>
																<td>
																	<strong>
																		{t('Title Type')}
																	</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.title_type_name}</td>
															</tr>
														</tbody>
													</table>
												</div>
												<div className='col-sm-12 col-lg-6'>
													<table className='table table-modern'>
														<tbody>
															<tr>
																<td style={{ width: '50%' }}>
																	<strong>
																		{t('Title Received Date')}
																	</strong>
																</td>
																<td>:</td>
																<td style={{ width: '40%' }}>
																	{vehicle?.title_received_date}
																</td>
															</tr>
															<tr>
																<td>
																	<strong>
																		{t('Title Number')}
																	</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.title_number}</td>
															</tr>
															<tr>
																<td>
																	<strong>
																		{t('Title State')}
																	</strong>
																</td>
																<td>:</td>
																<td>{vehicle?.title_state}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</CardBody>
									</Card>
									{vehicle?.export_id && (
										<Card>
											<CardBody>
												<div className='row'>
													<p className='lead fw-bold'>
														{t('Container Detail')}
													</p>
													<div className='col-sm-12 col-lg-6'>
														<table className='table table-modern'>
															<tbody>
																<tr>
																	<td
																		style={{
																			width: '50%',
																		}}>
																		<strong>
																			{t('Status')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td
																		style={{
																			width: '40%',
																		}}>
																		{vehicle?.status_name}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{t('Export Date')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.export_date}</td>
																</tr>
																<tr>
																	<td>
																		<strong>{t('ETA')}</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.eta}</td>
																</tr>
																<tr>
																	<td
																		style={{
																			width: '50%',
																		}}>
																		<strong>
																			{t('Arrived Date')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td
																		style={{
																			width: '40%',
																		}}>
																		{vehicle?.arrival_date}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{t('Booking Number')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{vehicle?.booking_number}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div className='col-sm-12 col-lg-6'>
														<table className='table table-modern'>
															<tbody>
																<tr>
																	<td>
																		<strong>
																			{t('Seal Number')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.seal_number}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{t('Container Number')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>
																		{vehicle?.container_number}
																	</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{t('Destination')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.destination}</td>
																</tr>
																<tr>
																	<td>
																		<strong>
																			{t('Ar Number')}
																		</strong>
																	</td>
																	<td>:</td>
																	<td>{vehicle?.ar_number}</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</CardBody>
										</Card>
									)}
								</div>
							) : (
								<h4 className='text-center'>Vehicle not found</h4>
							)}
						</div>
					</Card>
				</Page>
			</div>
		</>
	);
};

export default TrackingVehicle;
